import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export async function fetchSuperAdminDecisionCompanies() {
  const res = await fetch(`${API_BASE}/api/superadmin/decisions/companies`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الشركات'));
  const list = Array.isArray(data) ? data : [];
  return list.map((c) => ({ id: c.id, name: c.name }));
}

export async function fetchSuperAdminDecisionTypes(companyId = '') {
  const q = new URLSearchParams();
  if (companyId) q.set('companyId', String(companyId));
  const res = await fetch(`${API_BASE}/api/superadmin/decisions/decision-types?${q.toString()}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل أنواع القرارات'));
  const list = Array.isArray(data) ? data : [];
  return list.map((x) => ({ id: x.id, companyId: x.companyId, name: x.name }));
}

export async function fetchSuperAdminDecisions(params = {}) {
  const {
    page = 1,
    pageSize = 10,
    q = '',
    companyId = '',
    decisionTypeId = '',
    status = '',
    priority = '',
    fromDate = '',
    toDate = '',
    sortBy = 'createdAt',
    sortDir = 'desc',
  } = params;
  const query = new URLSearchParams();
  query.set('page', String(page));
  query.set('pageSize', String(pageSize));
  query.set('sortBy', sortBy);
  query.set('sortDir', sortDir);
  if (q.trim()) query.set('q', q.trim());
  if (companyId) query.set('companyId', String(companyId));
  if (decisionTypeId) query.set('decisionTypeId', String(decisionTypeId));
  if (status) query.set('status', status);
  if (priority) query.set('priority', priority);
  if (fromDate) query.set('fromDate', fromDate);
  if (toDate) query.set('toDate', toDate);

  const res = await fetch(`${API_BASE}/api/superadmin/decisions?${query.toString()}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل القرارات'));

  const items = Array.isArray(data.items) ? data.items : [];
  return {
    items: items.map((d) => ({
      id: d.id,
      companyId: d.companyId,
      companyName: d.companyName ?? '',
      decisionTypeId: d.decisionTypeId ? String(d.decisionTypeId) : '',
      decisionTypeName: d.decisionTypeName ?? '',
      title: d.title ?? '',
      description: d.description ?? '',
      creator: d.creator ?? '—',
      createdAt: d.createdAt ? String(d.createdAt).slice(0, 10) : '',
      status: d.status ?? 'pending',
      priority: d.priority ?? 'medium',
      deadline: d.deadline ? String(d.deadline).slice(0, 10) : '',
      totalMembers: Number(d.totalMembers ?? 0),
    })),
    page: Number(data.page) || 1,
    pageSize: Number(data.pageSize) || pageSize,
    total: Number(data.total) || 0,
    totalPages: Number(data.totalPages) || 0,
  };
}

export async function createSuperAdminDecision(payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/decisions`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة القرار'));
  return data;
}

export async function updateSuperAdminDecision(id, payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/decisions/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث القرار'));
  return data;
}

export async function deleteSuperAdminDecision(id) {
  const res = await fetch(`${API_BASE}/api/superadmin/decisions/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر حذف القرار'));
}
